import React from 'react';
import { Button, styled, ButtonProps } from '@mui/material';

const StyledButton = styled(Button)({
  textTransform: 'none',
  color: '#000000',
  fontSize: '16px',
  '&:hover': {
    backgroundColor: 'transparent',
  },
});

const TextButton: React.FC<ButtonProps> = (props) => {
  return <StyledButton variant="text" disableRipple {...props} />;
};

export default TextButton;
